import { Autocomplete, FormControl, TextField } from "@mui/material"
import React from "react"

const AutoComplete = ({
  options,
  label,
  className,
  onChange,
  selectedValue,
  setInputValue,
  setSelectedValue,
  height
}) => {

  return (
    <div className={className}>
      <FormControl fullWidth>
        <div className="ml-4 text-[14px] flex justify-start flex-col text-text-secondary mb-2">
          {label}
        </div>
        <Autocomplete
          className=" "
          freeSolo
          filterOptions={(x) => x}
          options={options}
          value={selectedValue}
          autoComplete
          includeInputInList
          filterSelectedOptions
          noOptionsText="No locations"
          onChange={(event, newValue) => {
            setSelectedValue(newValue)
            if (onChange) {
              onChange(newValue)
            }
          }}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue)
          }}
          sx={{
            width: "full",
            'fieldset': {
              top: 0,
              border: '1px solid',
              borderRadius: '8px',
              height: height ? height : "56px",
              marginTop: "5px",
              borderColor: 'var(--color-divider)',
              '--tw-border-opacity': '1',
              'legend': {
                display: 'none'
              }
            },
            'div': {
              height: height ? height : "56px",
            },
            'button': {
              marginTop: "12px",
            }
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </FormControl>
    </div>
  )
}

export default AutoComplete
